import { inject, Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { XProjectorXConfClient } from '@xprojectorcore/xprojector_backend/xprojector-xconf-client';
import { DateHelper } from 'xproj-lib';
import { BmsDataUtils, flakeId } from '../utils/bms-data-utils';
import { BmsSystemObjectCurve } from '../../models/bms-system-object-curve';
import { BasicResponse, GrpcNode } from '@xprojectorcore/xprojector_backend/proto/xprojector.grpc.models.pb';


@Injectable({
  providedIn: 'root'
})
export class BmsSystemObjectsService {

  private xconfClient: XProjectorXConfClient = inject(XProjectorXConfClient);
  private logger: NGXLogger = inject(NGXLogger);
  private dateHelper: DateHelper = inject(DateHelper);

  constructor() {

  }

  async getSystemObjectCurve(nodeId: string): Promise<BmsSystemObjectCurve> {
    let result : BmsSystemObjectCurve = new BmsSystemObjectCurve();
    let node = await this.xconfClient.getNode(nodeId, '_x_bms_systems_object');
    if (node) {
      result.id = nodeId;
      result.name = node.name;

      node.propertyValues.forEach(p => {
        switch (p.key) {

          case 'systemId':
            result.systemId = BmsDataUtils.getValue(p.valueType, p.value, p, this.dateHelper);
            break;
          case 'unit':
            result.unit = BmsDataUtils.getValue(p.valueType, p.value, p, this.dateHelper);
            break;
          case 'key':
            result.key = BmsDataUtils.getValue(p.valueType, p.value, p, this.dateHelper);
            break;
          case 'points':
            result.points = BmsDataUtils.getValue(p.valueType, p.value, p, this.dateHelper);
            break;
          case 'in1':
            result.in1 = BmsDataUtils.getValue(p.valueType, p.value, p, this.dateHelper);
            break;
          case 'out1':
            result.out1 = BmsDataUtils.getValue(p.valueType, p.value, p, this.dateHelper);
            break;
          case 'in2':
            result.in2 = BmsDataUtils.getValue(p.valueType, p.value, p, this.dateHelper);
            break;
          case 'out2':
            result.out2 = BmsDataUtils.getValue(p.valueType, p.value, p, this.dateHelper);
            break;
          case 'in3':
            result.in3 = BmsDataUtils.getValue(p.valueType, p.value, p, this.dateHelper);
            break;
          case 'out3':
            result.out3 = BmsDataUtils.getValue(p.valueType, p.value, p, this.dateHelper);
            break;
          case 'in4':
            result.in4 = BmsDataUtils.getValue(p.valueType, p.value, p, this.dateHelper);
            break;
          case 'out4':
            result.out4 = BmsDataUtils.getValue(p.valueType, p.value, p, this.dateHelper);
            break;
          case 'in5':
            result.in5 = BmsDataUtils.getValue(p.valueType, p.value, p, this.dateHelper);
            break;
          case 'out5':
            result.out5 = BmsDataUtils.getValue(p.valueType, p.value, p, this.dateHelper);
            break;
          case 'in6':
            result.in6 = BmsDataUtils.getValue(p.valueType, p.value, p, this.dateHelper);
            break;
          case 'out6':
            result.out6 = BmsDataUtils.getValue(p.valueType, p.value, p, this.dateHelper);
            break;
          case 'in7':
            result.in7 = BmsDataUtils.getValue(p.valueType, p.value, p, this.dateHelper);
            break;
          case 'out7':
            result.out7 = BmsDataUtils.getValue(p.valueType, p.value, p, this.dateHelper);
            break;
          case 'in8':
            result.in8 = BmsDataUtils.getValue(p.valueType, p.value, p, this.dateHelper);
            break;
          case 'out8':
            result.out8 = BmsDataUtils.getValue(p.valueType, p.value, p, this.dateHelper);
            break;
          case 'in9':
            result.in9 = BmsDataUtils.getValue(p.valueType, p.value, p, this.dateHelper);
            break;
          case 'out9':
            result.out9 = BmsDataUtils.getValue(p.valueType, p.value, p, this.dateHelper);
            break;
          case 'in10':
            result.in10 = BmsDataUtils.getValue(p.valueType, p.value, p, this.dateHelper);
            break;
          case 'out10':
            result.out10 = BmsDataUtils.getValue(p.valueType, p.value, p, this.dateHelper);
            break;


        }
      });
    }

    return result;
  }

  async saveSystemObjectCurve(curve: BmsSystemObjectCurve, customerId : string, curveNode: GrpcNode = undefined): Promise<BasicResponse> {
    if (!curveNode) {
      curveNode = await this.xconfClient.getNode(curve.id, '_x_bms_systems_object');
    }

    if (curveNode) {
      curve.modifiedAt = new Date();
      curveNode.name = curve.name;
      curveNode.propertyValues.forEach(p => {
        switch (p.key) {

          case 'unit':
            p.value = BmsDataUtils.getPropertyValue(p.valueType, curve.unit, this.dateHelper);
            break;
          case 'key':
            p.value = BmsDataUtils.getPropertyValue(p.valueType, curve.key, this.dateHelper);
            break;
          case 'points':
            p.value = BmsDataUtils.getPropertyValue(p.valueType, curve.points, this.dateHelper);
            break;
          case 'in1':
            p.value = BmsDataUtils.getPropertyValue(p.valueType, curve.in1, this.dateHelper);
            break;
          case 'out1':
            p.value = BmsDataUtils.getPropertyValue(p.valueType, curve.out1, this.dateHelper);
            break;
          case 'in2':
            p.value = BmsDataUtils.getPropertyValue(p.valueType, curve.in2, this.dateHelper);
            break;
          case 'out2':
            p.value = BmsDataUtils.getPropertyValue(p.valueType, curve.out2, this.dateHelper);
            break;
          case 'in3':
            p.value = BmsDataUtils.getPropertyValue(p.valueType, curve.in3, this.dateHelper);
            break;
          case 'out3':
            p.value = BmsDataUtils.getPropertyValue(p.valueType, curve.out3, this.dateHelper);
            break;
          case 'in4':
            p.value = BmsDataUtils.getPropertyValue(p.valueType, curve.in4, this.dateHelper);
            break;
          case 'out4':
            p.value = BmsDataUtils.getPropertyValue(p.valueType, curve.out4, this.dateHelper);
            break;
          case 'in5':
            p.value = BmsDataUtils.getPropertyValue(p.valueType, curve.in5, this.dateHelper);
            break;
          case 'out5':
            p.value = BmsDataUtils.getPropertyValue(p.valueType, curve.out5, this.dateHelper);
            break;
          case 'in6':
            p.value = BmsDataUtils.getPropertyValue(p.valueType, curve.in6, this.dateHelper);
            break;
          case 'out6':
            p.value = BmsDataUtils.getPropertyValue(p.valueType, curve.out6, this.dateHelper);
            break;
          case 'in7':
            p.value = BmsDataUtils.getPropertyValue(p.valueType, curve.in7, this.dateHelper);
            break;
          case 'out7':
            p.value = BmsDataUtils.getPropertyValue(p.valueType, curve.out7, this.dateHelper);
            break;
          case 'in8':
            p.value = BmsDataUtils.getPropertyValue(p.valueType, curve.in8, this.dateHelper);
            break;
          case 'out8':
            p.value = BmsDataUtils.getPropertyValue(p.valueType, curve.out8, this.dateHelper);
            break;
          case 'in9':
            p.value = BmsDataUtils.getPropertyValue(p.valueType, curve.in9, this.dateHelper);
            break;
          case 'out9':
            p.value = BmsDataUtils.getPropertyValue(p.valueType, curve.out9, this.dateHelper);
            break;
          case 'in10':
            p.value = BmsDataUtils.getPropertyValue(p.valueType, curve.in10, this.dateHelper);
            break;
          case 'out10':
            p.value = BmsDataUtils.getPropertyValue(p.valueType, curve.out10, this.dateHelper);
            break;
          case 'modifiedat':
            p.value = BmsDataUtils.getPropertyValue(p.valueType, curve.modifiedAt, this.dateHelper);
            break;
        }
      });

      return this.xconfClient.updateNode(curveNode, curveNode.id, '', customerId);
    }
    else {
      return new BasicResponse({ result: false, message: 'Error get system object curve node!' });
    }
  }
}
